import { coerceArray } from '@angular/cdk/coercion';
import { Router } from '@angular/router';
import { ProcessAdmin } from '@apps/file-process/file-process.state';
import { RouterLinkType } from '@core/common.types';

export function navigateNewWindow(router: Router, commands: any[]) {
  const baseUrl = window.location.href.replace(router.url, '');
  const url = new URL(commands.join('/'), baseUrl).href;
  window.open(url, '_blank');
}

export function navigateNewWindowByUrl(url: string) {
  window.open(url, '_blank');
}

export const navigateRouterLink = (router: Router, link: RouterLinkType) => {
  const navLink = coerceArray(link);
  router.navigate(navLink);
};

export const buildNavigateLegalEntityLink = (customerSpaceId: string, processType: string, legalEntityId: string) => {
  return ['/customer-spaces', customerSpaceId, 'file-process', processType, 'legal-entities', legalEntityId, 'processes'];
};

export const buildCreateUserWithProcessClientMainContactLink = (process: ProcessAdmin) => {
  return [
    '/',
    'customer-spaces',
    process.customerSpaceId,
    'file-process',
    process.type,
    'legal-entities',
    process.legalEntityId,
    'processes',
    process.id,
    'access',
    'create-user',
  ];
};
